export const FRENCH = [
  'A','A','A','A','A','A','A','A','A',
  'B','B',
  'C','C',
  'D','D','D',
  'E','E','E','E','E','E','E','E','E','E','E','E','E','E','E',
  'F','F',
  'G','G',
  'H','H',
  'I','I','I','I','I','I','I','I',
  'J',
  'K',
  'L','L','L','L','L',
  'M','M','M',
  'N','N','N','N','N','N',
  'O','O','O','O','O','O',
  'P','P',
  'Q',
  'R','R','R','R','R','R',
  'S','S','S','S','S','S',
  'T','T','T','T','T','T',
  'U','U','U','U','U','U',
  'V','V',
  'W',
  'X',
  'Y',
  'Z',
  ' ',' ',
]

export const FRENCH_POINTS = {
  'A': 1,
  'B': 3,
  'C': 3,
  'D': 2,
  'E': 1,
  'F': 4,
  'G': 2,
  'H': 4,
  'I': 1,
  'J': 8,
  'K': 10,
  'L': 1,
  'M': 2,
  'N': 1,
  'O': 1,
  'P': 3,
  'Q': 8,
  'R': 1,
  'S': 1,
  'T': 1,
  'U': 1,
  'V': 4,
  'W': 10,
  'X': 10,
  'Y': 10,
  'Z': 10,
  ' ': 0,
}
